import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TimeProvider, TimeEvent } from '../time.provider';
import { I18N } from 'ess-plugin-base';
import { Month, MonthCalendar } from '../calendar/month.calendar';

@Component({
    selector: 'event-viewer',
    templateUrl: './event.viewer.html',
    styleUrls: ['./event.viewer.scss'],
})
export class EventViewer implements OnInit, OnChanges {

    title: string;

    month: Month;

    viewDate: Date;

    events: TimeEvent[] = [];

    tagsets: any[] = [];

    showTimeline: boolean;

    monthFilter: any = {};

    timelineFilter: any = {};

    showEvent: boolean;

    selectedEvent: TimeEvent;

    activeTab: number = 1;

    constructor(private provider: TimeProvider, public i18n: I18N) {}

    ngOnInit() {
        this.viewDate = new Date();

        this.month = new Month();
        this.month.year = this.viewDate.getFullYear();
        this.month.rank = this.viewDate.getMonth();
        this.month.name = MonthCalendar.monthNames[this.month.rank];

        this.title = this.i18n.get('eventCalendar', 'Calendar');

        this.provider.getTagsets()
        .then(data => {
            this.tagsets = data;
        })

    }

    ngOnChanges(changes: SimpleChanges) {}

    dateSelected(date: Date) {
        this.viewDate = date;

        this.gotoTimeline();
    }

    tabChanged(event: any) {}

    gotoTimeline() {
        this.showTimeline = true;

        this.timelineFilter = {}; 
        this.timelineFilter.from = this.viewDate;
        this.timelineFilter.to = new Date(this.viewDate);
        this.timelineFilter.to.setDate(this.viewDate.getDate() + 1);

        if (this.monthFilter) {
            for(let key in this.monthFilter) {
                this.timelineFilter[key] = this.monthFilter[key];
            }
        }

        this.activeTab = 2;
    }

    gotoEvent(event: TimeEvent) {
        this.showEvent = true;
        this.selectedEvent = event; 

        this.activeTab = 3;
    }

    gotoMonth(filter: any) {
        this.viewDate = new Date();
        this.viewDate.setDate(1);
        this.viewDate.setMonth(filter.month);
        this.viewDate.setFullYear(filter.year);

        this.month.year = this.viewDate.getFullYear();
        this.month.rank = this.viewDate.getMonth();
        this.month.name = MonthCalendar.monthNames[this.month.rank];

        this.monthFilter = filter;

        this.activeTab = 1;
    }

    doAdd() {
        let event = new TimeEvent();
        this.gotoEvent(event);
    }
}